var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 7,
    stroke: "url(#paint0_linear_3668_998)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L17 17",
    stroke: "url(#paint1_linear_3668_998)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3668_998",
    x1: 11,
    y1: 4,
    x2: 11,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99479C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#51008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#301C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#090029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120049"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3668_998",
    x1: 18.5,
    y1: 17,
    x2: 18.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99479C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#51008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#301C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#090029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120049"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchP);
export default __webpack_public_path__ + "static/media/searchP.7a31f2913b4a9f47e1760bc069454995.svg";
export { ForwardRef as ReactComponent };